import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    tabletCol: { type: Boolean, default: false },
    mobileCol: { type: Boolean, default: false },
    row: { type: Boolean, default: false },
    col: { type: Boolean, default: false },
    className: { default: undefined },
    flex: { default: undefined },
    wrap: { default: undefined },
    basis: { default: undefined },
    width: { default: undefined },
    justify: { default: undefined },
    align: { default: undefined },
    alignSelf: { default: undefined },
    alignContent: { default: undefined },
    rowGap: { default: undefined },
    colGap: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { tabletCol: boolean, mobileCol: boolean, row: boolean, col: boolean, className: string, flex: [undefined | number, undefined | number], wrap: 'nowrap' | 'wrap' | 'wrap-reverse', basis: string | 'auto', width: string | 'auto', justify: '' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly', align: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline', alignSelf: 'auto' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch', alignContent:
			| 'flex-start'
			| 'flex-end'
			| 'center'
			| 'space-between'
			| 'space-around'
			| 'space-evenly'
			| 'stretch', rowGap: string, colGap: string }


const baseFlexClassName = computed(() => {
	const result = [];
	if (props.className) {
		result.push(props.className);
	}
	if (props.row) {
		result.push('base-flex-row');
		if (props.mobileCol) {
			result.push('base-flex-row--mobile-column');
		}
		if (props.tabletCol) {
			result.push('base-flex-row--tablet-column');
		}
	}
	if (props.col) {
		result.push('base-flex-column');
	}
	return result;
});
const style = computed<StyleObject>((): StyleObject => {
	const result: StyleObject = {};
	if (typeof props.flex !== 'undefined' && props.flex.length === 2) {
		const flexGrow: undefined | number = props.flex[0];
		const flexShrink: undefined | number = props.flex[1];
		if (typeof flexGrow !== 'undefined') {
			result.flexGrow = flexGrow;
		}
		if (typeof flexShrink !== 'undefined') {
			result.flexShrink = flexShrink;
		}
	}
	if (typeof props.wrap !== 'undefined') {
		result.flexWrap = props.wrap;
	}
	if (typeof props.basis !== 'undefined') {
		result.flexBasis = props.basis;
		result.width = props.basis;
	}
	if (typeof props.width !== 'undefined') {
		result.width = props.width;
	}
	if (typeof props.justify !== 'undefined') {
		result.justifyContent = props.justify;
	}
	if (typeof props.align !== 'undefined') {
		result.alignItems = props.align;
	}
	if (typeof props.alignSelf !== 'undefined') {
		result.alignSelf = props.alignSelf;
	}
	if (typeof props.alignContent !== 'undefined') {
		result.alignContent = props.alignContent;
	}
	if (typeof props.rowGap !== 'undefined') {
		result.rowGap = props.rowGap;
	}
	if (typeof props.colGap !== 'undefined') {
		result.columnGap = props.colGap;
	}
	return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-flex", _unref(baseFlexClassName)]),
    style: _normalizeStyle(_unref(style))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})